import React from 'react';
import { usePayabliHook } from "./usePayabliHook";
import { PaymentTabs } from "./PaymentTabs";
import { PaymentButton } from "./PaymentButton";
import { IPaymentObject } from "../../../utils/types";
import LoadingOverlay from '../../../components/insurance/LoadingOverlay';
interface PaymentPopupProps {
  closePopup: () => void;
  paymentObject: IPaymentObject;
  onSuccess?: (message: string, referenceId?: string) => void;
  onError?: (message: string) => void;
  paymentType?: string;
}

export default function PaymentPopup({ closePopup, paymentObject, onSuccess, onError, paymentType }: PaymentPopupProps) {
  const {
    selectedPaymentTab,
    setSelectedPaymentTab,
    isFormValid,
    isLoading,
    isProcessing,
    handlePaymentSubmit,
    PAYMENT_TABS
  } = usePayabliHook(paymentObject, onSuccess, onError, closePopup, paymentType);

  const paymentTabs = {
    [PAYMENT_TABS.CARD]: "Payment Card",
    [PAYMENT_TABS.BANK_DEBIT]: "Bank Debit",
    // STI-2495 (review R2): the wallet flow can't produce a vaultable method, so a recurring payment on
    // it would vault a one-time token and fail at cycle 2 with E7007. Don't offer Wallet for recurring.
    ...(paymentObject?.isRecurring ? {} : { [PAYMENT_TABS.WALLET]: "Wallet" }),
  };

  return (
    <div className={`fixed bg-black/50 inset-0 flex justify-center items-center z-50 text-black`}>
      {isLoading && <LoadingOverlay />}
      <div className={`w-[95%] max-w-sm sm:max-w-md mx-auto border-2 rounded-lg p-3 sm:p-6 bg-white shadow-lg relative modal-content ${isLoading ? 'hidden' : ''}`}>
        <button
          className="absolute top-2 right-2 text-gray-600 hover:text-gray-800 text-lg sm:text-xl p-2"
          onClick={closePopup}
        >
          ✕
        </button>
        <h4 className="text-base sm:text-lg font-bold text-gray-700 mb-4 text-center pt-2">Payment Method</h4>

        <PaymentTabs
          selectedTab={selectedPaymentTab}
          onTabChange={setSelectedPaymentTab}
          tabs={paymentTabs}
        />

        <div className="min-h-[300px] sm:min-h-[400px]">
          <div id="pay-component-card"></div>
        </div>
        
        <PaymentButton
          isFormValid={isFormValid}
          isProcessing={isProcessing}
          isScheduled={paymentObject.isRecurring}
          onClick={handlePaymentSubmit}
        />
      </div>
    </div>
  );
}